var smiBlock = smiBlock || {};
var templateMap = templateMap || [];
jQuery(function($) {
    var regex = /msie|Trident.*rv[ :]*11\./gi, isIE = regex.test(window.navigator.userAgent);

    var cdnDomain, feedDomain, feedDir, defaultImageSrc;

    if((typeof siteConfig == 'object') && siteConfig.url.cdn) cdnDomain = siteConfig.url.cdn;

    var blockDebug = document.location.search.indexOf('blockDebug=1') !== -1, blockCount = 0, noHeadingCount = 0, widgetRight = 1, loadedTemplates = [], usedInPage = [],
        feeds = [], fetchedTemplates = [], prevHeading, ad;

    switch(window.location.hostname) {
        case 'www.sonomanews.com' :
        case 'sit.stage.ew.srp.navigacloud.com' :
        case 'sit.everywarestarterkit.local' :
            feedDomain = 'sonomanews.com';
            feedDir = 'sit2018';
            defaultImageSrc = 'https://img.sonomanews.com/default.png';
            break;
        case 'www.petaluma360.com' :
        case 'pac.stage.ew.srp.navigacloud.com' :
        case 'pac.everywarestarterkit.local' :
            feedDomain = 'petaluma360.com';
            feedDir = 'pac2018';
            defaultImageSrc = 'https://img.petaluma360.com/default.png';
            break;
        case 'www.northbaybusinessjournal.com' :
        case 'nbbj.stage.ew.srp.navigacloud.com' :
        case 'nbbj.everywarestarterkit.local' :
            feedDomain = 'northbaybusinessjournal.com';
            feedDir = 'nbbj2018';
            defaultImageSrc = 'https://img.northbaybusinessjournal.com/default.png';
            break;
        case 'www.sonomacountygazette.com' :
        case 'scg.stage.ew.srp.navigacloud.com' :
        case 'scg.everywarestarterkit.local' :
            feedDomain = 'pressdemocrat.com';
            feedDir = 'pd2018';
            defaultImageSrc = 'https://img.sonomacountygazette.com/default.png';
            break;
        case 'www.laprensasonoma.com' :
        case 'lps.stage.ew.srp.navigacloud.com' :
        case 'lps.everywarestarterkit.local' :
            feedDomain = 'pressdemocrat.com';
            feedDir = 'pd2018';
            defaultImageSrc = 'https://img.laprensasonoma.com/default.png';
            break;
        default :
            feedDomain = 'pressdemocrat.com';
            feedDir = 'pd2018';
            defaultImageSrc = 'https://img.pressdemocrat.com/default.png';
            break;
    }

    smiBlock.adaptImages = function(el, forceAll) {
        adaptImages(el, forceAll);
    };

    smiBlock.do = function(block, blockData, onSuccess, onComplete) {
        doBlock(block, blockData, onSuccess, onComplete);
    };

    smiBlock.get = function(parent) {
        if(parent) parent = (typeof parent === 'string' || parent instanceof String) ? $(parent) : parent; else parent = $('body');

        parent.find('.dynamic-content-block, .tpl2022__build-block').not('.fetching').not('.rendered').first().each(function() {
            getThisBlock($(this), parent);
        });

        function getThisBlock(block, parent) {
            block.addClass('fetching');
            doBlock(block, block.data(), function() {
                block.addClass('rendered');
            }, function() {
                smiBlock.get(parent);
            });
        }
    };

    function adaptAllHeadlines() {
        $('[data-stretch-headlines]').each(function() {
            var block = $(this).closest('.tpl2022__build-block, .tpl2022__block');
            adaptHeadlines(block);
        });
    }

    function adaptHeadlines(block) {
        block.find('[data-stretch-headlines]').each(function() {
            var headlines = $(this).find('.tpl2022__headline h3'), maxStretchFactor = $(this).data('stretch-headlines');

            headlines.css({
                fontSize: '', lineHeight: '', maxHeight: ''
            });

            if(headlines.length && maxStretchFactor) {
                var growUntilFit = function(h3, baseFontSize, iteration) {
                    var fontSize = parseFloat(h3.css('font-size')), lineHeight = parseFloat(h3.css('line-height')), maxHeight = parseFloat(h3.css('max-height')),
                        lineHeightRatio = (lineHeight / fontSize).toFixed(3), fontSizeNew = (fontSize + 1).toFixed(1), h3Rows, h3RowsNew;

                    if(isNaN(maxHeight)) {
                        h3.css({maxHeight: 'none', lineHeight: lineHeightRatio});
                        h3Rows = (h3.height() / (lineHeightRatio * fontSize)).toFixed(0);

                        if(h3Rows > 1 && maxStretchFactor > 1.25) maxStretchFactor = maxStretchFactor = 1.25;

                        h3.css('font-size', fontSizeNew + 'px');
                        h3RowsNew = (h3.height() / (lineHeightRatio * fontSizeNew)).toFixed(0);
                        if(h3Rows === h3RowsNew) {
                            if(fontSizeNew <= (baseFontSize * maxStretchFactor)) {
                                return growUntilFit(h3, baseFontSize, ++iteration);
                            }
                        }
                        h3.css('font-size', fontSize + 'px');
                    }
                    return false;
                };

                $.each(headlines, function() {
                    var h3 = $(this), baseFontSize = parseFloat(h3.css('font-size'));

                    growUntilFit(h3, baseFontSize, 1);
                });
            }
        });
    }

    function adaptImages(el, forceAll) {
        if(el) el = (typeof el === 'string' || el instanceof String) ? $(el) : el; else el = $('body');

        el.find('.tpl2022__image img[data-src]:visible').each(function() {
            var image = $(this);

            if(forceAll || isAboveBottomOfViewport(image)) {
                image.one('load', function() {
                    image.addClass('loaded', true);
                    $(document).trigger('tpl2022:imageLoaded', image);
                    image.trigger('tpl2022:imageLoaded');
                });

                var imageSrc = image.data('src') || defaultImageSrc;
                image.attr('src', imageSrc);
                image.attr('srcset', image.data('srcset'));
                image.attr('sizes', image.data('sizes'));

                image.removeAttr('data-src');
                image.removeAttr('data-srcset');
                image.removeAttr('data-sizes');

                if(isIE) {
                    var fakeImage = image.parent('a');
                    if(fakeImage.length) {
                        fakeImage.addClass('ie-polyfill');
                        fakeImage.css('background-image', 'url(' + imageSrc + ')');
                    }
                }
            }
        });
    }

    function buildWidget(widgetSettings) {
        var slotSize = widgetSettings.size, widgetVar = 'widgetQueue', forceType = (typeof widgetSettings.forceType !== 'undefined') ? widgetSettings.forceType : false,
            widget, thisWidget, widgetType, toShow;

        if(typeof window[widgetVar] === 'undefined') return false; // skip widget area

        if(typeof window[widgetVar][slotSize] === 'undefined') return false; // skip widget area

        if(!window[widgetVar][slotSize].length) return false; // skip widget area

        if(forceType) {
            thisWidget = window[widgetVar][slotSize].find(function(slot, index, array) {
                if(slot.type === forceType) {
                    array.splice(index, 1);
                    return true;
                }
            });
        } else if(slotSize === 'named' && (typeof widgetSettings.name !== 'undefined')) {
            thisWidget = window[widgetVar][slotSize].find(function(slot, index, array) {
                if(slot.name === widgetSettings.name) {
                    array.splice(index, 1);
                    return true;
                }
            });
        } else if(slotSize === 'custom' && (typeof widgetSettings.height !== 'undefined')) {
            const desiredHeight = parseInt(widgetSettings.height);

            thisWidget = window[widgetVar][slotSize].find(function(slot, index, array) {
                if(parseInt(slot.height) === desiredHeight) {
                    array.splice(index, 1);
                    return true;
                }
            });

            if(!thisWidget) {
                // if there was not an exact match, check within acceptable range
                const minHeight = desiredHeight - 60;
                const maxHeight = desiredHeight + 40;

                thisWidget = window[widgetVar][slotSize].find(function(slot, index, array) {
                    const slotHeight = parseInt(slot.height);
                    if(slotHeight >= minHeight && slotHeight <= maxHeight) {
                        array.splice(index, 1);
                        return true;
                    }
                });
            }
        } else {
            thisWidget = window[widgetVar][slotSize].shift();
        }

        if(typeof thisWidget !== 'object') return false; // skip widget area

        if(typeof thisWidget.type !== 'string') return false; // skip widget area

        widgetType = thisWidget.type;

        toShow = thisWidget.show || {};

        var theBody = $('body'), isAdFree = theBody.hasClass('ad-free'), isAdLite = theBody.hasClass('ad-lite'), widgetHeading = thisWidget.heading,
            showIfAdFree = typeof toShow.adFree === 'boolean' && toShow.adFree === true, showIfAdLite = typeof toShow.adLite === 'boolean' && toShow.adLite === true,
            widgetDelay = typeof thisWidget.delay === 'number' ? thisWidget.delay : 0, addClasses = thisWidget.classes || '',
            addAttributes = JSON.parse(thisWidget.attributes || '{}');

        // whether to serve the widget or non-widget version of a template
        if(isAdFree && !showIfAdFree) {
            return false; // skip widget area
        } else if((isAdFree || isAdLite) && !showIfAdLite) {
            return false; // skip widget area
        }

        if(blockDebug && blockCount > 0) {
            console.log('BLK:', blockCount + ') WIDGET TYPE: ' + widgetType);
            console.log('BLK:', blockCount + ') WIDGET DELAY: ' + widgetDelay + 'ms');
        }

        if(widgetType === 'ad') {
            widget = smiDfp.buildAdWrapper();

            $.each(widgetSettings.ads, function(i, v) {
                var adClass = $.trim((v.classes || '') + ' ' + addClasses) || null, adStyle = v.style || null;

                ad = smiDfp.buildAd(v.view, adClass, adStyle);

                if(Array.isArray(v.size[0])) {
                    $.each(v.size, function(i2, sz) {
                        ad.addSize(sz[0], sz[1]);
                    });
                } else {
                    ad.addSize(v.size[0], v.size[1]);
                }

                $.each(addAttributes, function(attribute, value) {
                    ad.addAttribute(attribute, value);
                });

                if(typeof thisWidget.targeting !== 'undefined' && thisWidget.targeting) {
                    $.each(thisWidget.targeting, function(tKey, tValue) {
                        ad.addTargeting(tKey, tValue);
                    });
                }

                if(showIfAdFree) {
                    ad.setShowAdFree(true);
                } else if(showIfAdLite) {
                    ad.setShowAdLite(true);
                }

                if(widgetDelay) ad.setDelay(widgetDelay);

                ad.wrapWith(widget);
            });

            widgetDelay = 0; // to turn off qat render time because it is handled by ad code
        } else if(widgetType === 'widget') {
            widget = $('<div class="tpl2022__widget-inner"/>');
            if(widgetHeading) {
                $('<div/>', {
                    'class': 'dark-heading', 'html': widgetHeading
                }).appendTo(widget);
            }

            if(showIfAdFree) {
                widget.addClass('show-ad-free');
            } else if(showIfAdLite) {
                widget.addClass('show-ad-lite');
            }

            widget.append(thisWidget.code);
        }

        if(!widget) return;

        return {
            type: widgetType, delay: widgetDelay, settings: widgetSettings, html: widget
        };
    }

    function fetchTemplate(name, callback) {
        if(fetchedTemplates.indexOf(name) !== -1) return callback.call();

        fetchedTemplates.push(name);

        var hasMap = $.grep(templateMap, function(e) {
            return e.id === name;
        });

        if(hasMap.length) return callback.call();

        if(!cdnDomain) return callback.call();

        if(blockDebug) console.log('BLK:', '*** Fetching Template: (' + name + ')');

        $.get({
            url: cdnDomain + '/tpl2022/blocks/' + name + '.html'
        }).done(function(data) {
            if(blockDebug) console.log('BLK:', '*** Template Fetched: (' + name + ')');
            $('body').append(data);
            callback.call();
        }).fail(function() {
            if(blockDebug) console.error('BLK:', '*** Template Failed: (' + name + ')');
            callback.call();
        });
    }

    function doBlock(block, blockData, onSuccess, onComplete) {
        blockCount++;
        if(blockDebug) console.log('BLK:', '*** Fetching Block (' + blockCount + ')');

        if(!block.length) return;
        if(!blockData.template) return;

        var tplName = blockData.template.toLowerCase(), tplBaseName = tplName.replace(/^nw-/, ''), tplId = '#tpl-' + tplName, is2022 = block.is('.tpl2022__build-block'),
            showWidget = !(!!blockData.hideWidget || (tplName.indexOf('nw-') === 0));

        fetchTemplate(tplBaseName, function() {
            var tplConfig = $.grep(templateMap, function(e) {
                return e.id === tplBaseName;
            });

            if(!$(tplId).length) tplId = '#tpl-' + tplBaseName;

            var templateWrap = !(blockData.path), localFeedExpire = 300, // in seconds
                widgets = [], widgetQueue = [], widgetClass, hasParentWidget, forceShowWidget, widgetSide, req, url, params, storyData, layout, hasWidget, maxStories,
                deDupe, countDupe, cacheKey, heading, subheading;

            function successHandler(data) {
                var tpl = getTemplate(data), tplHeader, tplStoryMap;

                if(tpl !== false) {
                    tpl = $(tpl);

                    tpl.addClass(widgetClass);

                    // move any modifier classes to 'tpl' rather than 'block'
                    $.each(block.prop('className').split(' '), function(i, className) {
                        if(className.match(/^tpl2022--/)) {
                            block.removeClass(className);
                            tpl.addClass(className);
                            if(blockDebug) console.log('BLK:', blockCount + ') CHANGE: class ' + className + ' moved from block to tpl');
                        }
                    });

                    block.attr('data-cache-key', cacheKey).html(tpl);

                    tplHeader = block.find('.template-heading, .tpl2022__heading');
                    tplStoryMap = block.find('.has-size-map');

                    var tplAccentColor = block.data('custom-accentcolor');
                    if(tplAccentColor) tpl.css('--tpl-accent-color', tplAccentColor);

                    if(block.data('custom-allowgallery')) {
                        var galleryFired = false;
                        block.on('tpl2022:blockLoaded', function() {
                            if(!galleryFired) {
                                galleryFired = true;
                                if(typeof tplConfig.slots.galleryIn === 'object') {
                                    $.each(tplConfig.slots.galleryIn, function(i, aIdx) {
                                        var galleryArticle = block.find('.article-' + aIdx).first(), galleryImage = galleryArticle.find('.tpl2022__image img');
                                        $(document).trigger('tpl2022:forceGallery', galleryImage);
                                    });
                                }
                            }
                        });
                    }

                    if(templateWrap) tpl.addClass('tpl2022--is-wrapper');

                    if(block.closest('.tpl2022--is-wrapper').length) block.addClass('tpl2022--is-wrapped');

                    if(tplHeader.length) {
                        if(heading) {
                            noHeadingCount = 0;
                            var headingTag = $('<span />', {html: heading});

                            if(is2022) {
                                tpl.addClass('tpl2022--has-heading');
                            } else {
                                tpl.addClass('has-heading');
                            }

                            if(data && typeof data.link !== 'undefined' && data.link.url) {
                                var target = data.link.target || '_self', aTag = $('<a />', {target: '_self', href: data.link.url, html: heading});
                                headingTag.html(aTag);
                            }

                            tplHeader.html(headingTag);
                            if(subheading) {
                                headingTag.append('&nbsp;&nbsp;<small>' + subheading + '</small>');
                            }
                        } else {
                            noHeadingCount++;

                            if(is2022) {
                                tpl.addClass('tpl2022--no-heading tpl2022--no-heading-' + noHeadingCount);
                            } else {
                                tpl.addClass('no-heading no-heading-' + noHeadingCount);
                            }

                            if(typeof layout.forceHeadSpace === 'undefined' || !layout.forceHeadSpace) {
                                tplHeader.remove();
                            }
                        }
                    }

                    if(tplStoryMap.length) {
                        $.each(tplStoryMap, function() {
                            var storyBlock = $(this), breakpoints = storyBlock.data('size-map');
                            if(breakpoints !== 'undefined') {
                                resizeStories(storyBlock, breakpoints);
                                $(document).on('tpl2022:resizeStories', function() {
                                    resizeStories(storyBlock, breakpoints);
                                });
                            }
                        });
                    }

                    setTimeout(function() {
                        widgetHandler();
                        adaptHeadlines(block);
                        adaptImages(block);

                        if($.isFunction(tplConfig.callbacks.success)) {
                            tplConfig.callbacks.success.call(block);
                        }
                        if(typeof blockData.onsuccess !== 'undefined' && $.isFunction(window[blockData.onsuccess])) {
                            window[blockData.onsuccess](block);
                        }
                        if($.isFunction(onSuccess)) {
                            onSuccess.call(block);
                        }

                        $(document).trigger('tpl:blockLoaded', block);
                        $(document).trigger('tpl2022:blockLoaded', block);
                        block.trigger('tpl:blockLoaded');
                        block.trigger('tpl2022:blockLoaded');
                    });
                }
            }

            function alwaysHandler() {
                if(tplConfig.length) {
                    if($.isFunction(tplConfig.callbacks.complete)) {
                        tplConfig.callbacks.complete.call(block);
                    }
                }

                if(typeof blockData.oncomplete !== 'undefined' && $.isFunction(window[blockData.oncomplete])) {
                    window[blockData.oncomplete](block);
                }

                if($.isFunction(onComplete)) {
                    onComplete.call(block);
                }
            }

            function buildWidgets() {
                if(tplConfig.length) {
                    tplConfig = tplConfig[0];

                    if(showWidget) {
                        $.each(tplConfig.widgets, function(i, widgetSettings) {
                            if(widgetSettings.size === 'queue') {
                                var widgetList = blockData.customWidgetqueue || widgetSettings.default;
                                if(widgetList) {
                                    var widgetItems = widgetList.split(',');
                                    $.each(widgetItems, function(i, widgetItem) {
                                        var widgetBits = widgetItem.split(':');

                                        widgetSettings = {};
                                        widgetSettings.size = widgetBits.shift();
                                        switch(widgetSettings.size) {
                                            case 'named':
                                                widgetSettings.name = widgetBits.shift();
                                                break;
                                            case 'custom':
                                                widgetSettings.height = widgetBits.shift();
                                                break;
                                            case 'cube':
                                            case 'half':
                                            case 'leaderboard':
                                                var showAdFor = widgetBits.shift(), viewFor = [];

                                                if(!showAdFor) showAdFor = 'ptd';

                                                if(showAdFor.indexOf('p') !== -1) viewFor.push('phone');
                                                if(showAdFor.indexOf('t') !== -1) viewFor.push('tablet');
                                                if(showAdFor.indexOf('d') !== -1) viewFor.push('desktop');

                                                widgetSettings.ads = [];

                                                if(widgetSettings.size === 'cube') {
                                                    widgetSettings.ads.push({
                                                        view: viewFor.join(','), size: [300, 250], class: 'widget-cube'
                                                    });
                                                }
                                                if(widgetSettings.size === 'half') {
                                                    if(viewFor.indexOf('phone') !== -1) {
                                                        widgetSettings.ads.push({
                                                            view: 'phone', size: [300, 250], class: 'widget-cube'
                                                        });
                                                    }
                                                    if(viewFor.indexOf('tablet') !== -1) {
                                                        widgetSettings.ads.push({
                                                            view: 'tablet', size: [300, 600], class: 'widget-half'
                                                        });
                                                    }
                                                    if(viewFor.indexOf('desktop') !== -1) {
                                                        widgetSettings.ads.push({
                                                            view: 'desktop', size: [300, 600], class: 'widget-half'
                                                        });
                                                    }
                                                }
                                                if(widgetSettings.size === 'leaderboard') {
                                                    if(viewFor.indexOf('phone') !== -1) {
                                                        widgetSettings.ads.push({
                                                            view: 'phone', size: [[320, 50], [320, 50]], class: 'widget-leaderboard'
                                                        });
                                                    }
                                                    if(viewFor.indexOf('tablet') !== -1) {
                                                        widgetSettings.ads.push({
                                                            view: 'tablet', size: [728, 90], class: 'widget-leaderboard'
                                                        });
                                                    }
                                                    if(viewFor.indexOf('desktop') !== -1) {
                                                        widgetSettings.ads.push({
                                                            view: 'desktop', size: [[970, 90], [728, 90]], class: 'widget-leaderboard'
                                                        });
                                                    }
                                                }
                                        }

                                        var widget = buildWidget(widgetSettings);
                                        if(widget) widgetQueue.push(widget);
                                    });
                                }
                            } else {
                                var widget = buildWidget(widgetSettings);
                                if(widget) widgets.push(widget);
                            }
                        });
                    }
                }

                return !!widgets.length || !!widgetQueue.length;
            }

            function doWidget(block, widget) {
                if(widget.html) {
                    widget.container.addClass('tpl2022__widget--' + widget.settings.size);
                    if(typeof widget.settings.class === 'string') widget.container.addClass('tpl2022__widget--' + widget.settings.class);
                    setTimeout(function() {
                        widget.container.html(widget.html);
                        smiBlock.get(widget.container);
                        smiDfp.loadAds(widget.container);
                        block.trigger('tpl:widgetLoaded', widget);
                    }, widget.delay);
                }
            }

            function widgetHandler() {
                if(hasWidget) {
                    block.find('.widget-holder, .tpl2022__widget').each(function() {
                        var widget = widgets.shift();
                        widget.container = $(this);
                        doWidget(block, widget);
                    });

                    block.find('.tpl2022__widget-queue').each(function() {
                        var widget;
                        while((widget = widgetQueue.shift())) {
                            widget.container = $('<aside class="tpl2022__widget"></aside>');
                            $(this).append(widget.container);
                            doWidget(block, widget);
                        }
                    });
                } else {
                    block.find('.has-widget').removeClass('has-widget').addClass('no-widget');
                    block.find('.tpl2022--has-widget').removeClass('tpl2022--has-widget').addClass('tpl2022--no-widget');
                }
            }

            function resizeStories(storyBlock, breakpoints) {
                $.each(breakpoints, function(i, v) {
                    if(window.matchMedia('(min-width: ' + i + 'px)').matches) {
                        storyBlock.removeClass().addClass('has-size-map').addClass(v);
                    }
                });
            }

            function getTemplate(data) {
                var ts = tplId, template;

                if(typeof loadedTemplates[ts] === 'undefined' && loadedTemplates[ts] !== false) {
                    template = $(ts);
                    if(template.length) {
                        loadedTemplates[ts] = Template7(template.html()).compile();
                    } else {
                        loadedTemplates[ts] = false;
                    }
                }

                if(loadedTemplates[ts]) {
                    if(templateWrap && !data) {
                        Template7.unregisterPartial('toBeWrapped');
                        Template7.registerPartial('toBeWrapped', block.html());
                        return loadedTemplates[ts]({hasWidget: !!hasWidget});
                    } else {
                        var stories = {};
                        if($.isArray(req.map)) {
                            $.each(req.map, function(i, v) {
                                stories[v.tArea] = stories[v.tArea] || [];
                                stories[v.tArea].push.apply(stories[v.tArea], data[v.area]);
                            });
                        } else {
                            stories.stories = data.stories;
                        }

                        stories.stories = filterStories(stories.stories);
                        if(!$.isEmptyObject(stories) && stories.stories.length && (stories.stories.length === maxStories || tplConfig.slots.requireAll === false)) {
                            stories.hasWidget = !!hasWidget;
                            return loadedTemplates[ts](stories);
                        }
                        if(blockDebug) console.error('BLK:', blockCount + ') RENDERING FAILED: ' + stories.stories.length + ' of ' + maxStories + ' required stories');
                    }
                }

                return false;
            }

            function filterStories(stories) {
                var imgRequiredIn = tplConfig.slots.reqImageIn || [], filteredStories = stories, usedStories = [];

                if(!filteredStories || !filteredStories.length) return false;

                if(deDupe) {
                    filteredStories = stories.filter(function(story) {
                        return $.inArray(story.cmsId, usedInPage) === -1;
                    });
                }

                filteredStories = filteredStories.slice(0, maxStories);

                var i, storyCount = filteredStories.length;
                for(i = 0; i < storyCount; i++) {
                    var storyObj = shuffleForImageRequired(i);
                    if(storyObj && (typeof storyObj.cmsId !== 'undefined')) {
                        if(countDupe) usedInPage.push(storyObj.cmsId);
                        usedStories.push(storyObj);
                    }
                }

                if(typeof blockData.ref !== 'undefined' && blockData.ref.length) {
                    $.each(usedStories, function(i, v) {
                        v.href = updateQueryStringParameter('ref', blockData.ref, v.href);
                        usedStories[i] = v;
                    });
                }

                return usedStories;

                function shuffleForImageRequired(iteration, trialCount) {
                    if(!trialCount) trialCount = 0;
                    var storyObj = filteredStories[0];

                    if(storyObj && (typeof storyObj.image.thumb !== 'undefined')) {
                        if($.inArray(iteration, imgRequiredIn) !== -1 && !storyObj.image.thumb) {
                            trialCount = (trialCount + 1);
                            if(trialCount < filteredStories.length) {
                                filteredStories.splice(0, 0, filteredStories.splice(trialCount, 1)[0]);
                                return shuffleForImageRequired(iteration, trialCount);
                            }
                        }
                    }

                    return filteredStories.shift();
                }
            }

            if(!tplConfig.length) {
                console.error(blockCount + ') NO CONFIG:   ' + tplId);
                alwaysHandler();
                return;
            }

            if(blockDebug) console.log('BLK:', blockCount + ') TEMPLATE:    ' + tplId);

            if(!templateWrap) {
                req = getRoute(blockData.path);
                url = req.url;
                params = req.params;
                storyData = req.data;
                if(blockDebug) console.log('BLK:', blockCount + ') URL:         ' + url);
            }

            hasWidget = buildWidgets();
            hasParentWidget = block.closest('.has-widget, .tpl2022--has-widget').length;
            tplConfig.slots = tplConfig.slots || {};
            tplConfig.callbacks = tplConfig.callbacks || {};
            maxStories = tplConfig.slots.hasWidget || 0;
            deDupe = typeof tplConfig.slots.deDupe !== 'undefined' ? !!tplConfig.slots.deDupe : (typeof blockData.dedupe !== 'undefined' ? !!blockData.dedupe : true);
            countDupe = typeof tplConfig.slots.countDupe !== 'undefined' ? !!tplConfig.slots.countDupe : (typeof blockData.countdupe !== 'undefined' ? !!blockData.countdupe : deDupe);
            heading = blockData.heading || false;
            subheading = blockData.subheading || false;

            layout = tplConfig.layout || {};
            forceShowWidget = typeof layout.forceShow !== 'undefined' && layout.forceShow;

            widgetClass = is2022 ? 'tpl2022--no-widget' : 'no-widget';
            // check if there is a widget available or, if child, parent has a widget or widget definition says to include widget area
            if(is2022 && (hasWidget || hasParentWidget)) {
                if(typeof layout.widgetCol === 'string') {
                    widgetSide = layout.widgetCol;
                    if(typeof ad === 'object') {
                        if(layout.widgetCol === 'auto') {
                            widgetSide = widgetRight ? 'right' : 'left';
                            widgetRight = !widgetRight;
                        }
                    } else {
                        widgetSide = 'right';
                    }

                    widgetClass = 'tpl2022--has-widget tpl2022--has-widget-' + widgetSide;
                }
            } else if(hasWidget || hasParentWidget || forceShowWidget) {
                if(typeof layout.widgetCol !== 'undefined' && layout.breakAt !== 'undefined') {
                    widgetSide = layout.widgetCol;
                    if(typeof ad === 'object') {
                        if(layout.widgetCol === 'auto') {
                            widgetSide = widgetRight ? 'right' : 'left';
                            widgetRight = !widgetRight;
                        }
                    } else {
                        widgetSide = 'right';
                    }

                    widgetClass = 'has-widget widget-' + widgetSide + '-' + layout.breakAt;
                }
            } else {
                var tplIdTemp = '#tpl-nw-' + tplBaseName;
                if($(tplIdTemp).length) tplId = tplIdTemp;
                maxStories = parseInt(tplConfig.slots.noWidget || 0);
                hasWidget = false;
            }

            maxStories = (typeof blockData.maxStories !== 'undefined') ? blockData.maxStories : maxStories;

            if(heading === prevHeading) heading = false; else prevHeading = heading;

            if(!templateWrap) localFeedExpire = 0;

            if(templateWrap) {

                if(blockDebug) console.log('BLK:', blockCount + ') DATA FROM:   n/a');
                successHandler();
                alwaysHandler();
                return true;

            } else {

                cacheKey = hashedUrl(url, params);

                if(typeof feeds[cacheKey] === 'object') {
                    var feedData = feeds[cacheKey];
                    if(blockDebug) console.log('BLK:', blockCount + ') DATA FROM:   feed in memory');
                    successHandler(feedData);
                    alwaysHandler();
                    return true;
                }

                if(storyData) {

                    if(blockDebug) console.log('BLK:', blockCount + ') DATA FROM:   on page variable');
                    feeds[cacheKey] = storyData;
                    successHandler(storyData);
                    alwaysHandler();
                    return true;

                } else {

                    try {
                        if(sessionStorage) {
                            var cached = sessionStorage.getItem(cacheKey), whenCached = sessionStorage.getItem(cacheKey + ':ts');

                            if(cached !== null && whenCached !== null) {
                                var age = (Date.now() - whenCached) / 1000;
                                if(age < localFeedExpire) {
                                    var data = JSON.parse(cached);
                                    if(typeof data === 'object') {
                                        if(blockDebug) console.log('BLK:', blockCount + ') DATA FROM:   session storage');
                                        feeds[cacheKey] = data;
                                        successHandler(data);
                                        alwaysHandler();
                                        return true;
                                    }
                                } else {
                                    sessionStorage.removeItem(cacheKey);
                                    sessionStorage.removeItem(cacheKey + ':ts');
                                }
                            }
                        }
                    } catch(e) {
                        $.noop();
                    }

                    if(url.indexOf('http') !== -1) {
                        $.ajax({
                            dataType: 'json', url: url, data: params, timeout: 6000
                        }).done(function(data) {
                            feeds[cacheKey] = data;
                            try {
                                if(sessionStorage) {
                                    sessionStorage.setItem(cacheKey, JSON.stringify(data));
                                    sessionStorage.setItem(cacheKey + ':ts', Date.now());
                                }
                            } catch(e) {
                                try {
                                    if(sessionStorage) {
                                        sessionStorage.clear();
                                    }
                                } catch(e) {
                                    $.noop();
                                }
                            }
                            if(blockDebug) console.log('BLK:', blockCount + ') DATA FROM:   $.getJSON()');
                            successHandler(data);
                        }).always(function() {
                            alwaysHandler();
                        }).fail(function() {
                            if(blockDebug) {
                                console.error('BLK:', blockCount + ') JSON ERROR: failed to fetch ' + url);
                            }
                        });
                    } else {
                        console.error('BLK:', blockCount + ') DATA ERROR: no way to fetch data for ' + url + '. It may be empty or it may not exist.');

                        alwaysHandler();
                    }
                }
            }
        });
    }

    function getRoute(feedPath) {
        var feedUrl, feedParams = {};

        if(feedPath.indexOf('/') === -1) {
            return {
                url   : feedPath, // used to create key for cached feed
                params: feedPath, // used to create key for cached feed
                map   : null, data: window[feedPath]
            };
        }

        feedPath = feedPath.toLowerCase().replace(/^\/+|\/+$/g, '');
        if(feedPath.indexOf('http') === 0) {
            feedUrl = feedPath;
        } else {
            feedUrl = 'https://feeds.' + feedDomain + '/' + feedDir + '/' + feedPath + '.json';
            feedParams.v = '20210824';
        }

        return {
            url: feedUrl, params: feedParams, map: null, data: null
        };
    }

    function hashedUrl(url, params) {
        var hash = 0, qs = '', i;
        if(params && (typeof params === 'object')) qs = '?' + decodeURIComponent($.param(params));
        url = url + qs;

        if(url.length === 0) return hash;
        for(i = 0; i < url.length; i++) {
            var char = url.charCodeAt(i);
            hash = ((hash<<5) - hash) + char;
            hash = hash&hash;
        }
        return hash;
    }

    function isAboveBottomOfViewport(el) {
        el = (typeof el === 'string' || el instanceof String) ? $(el) : el;
        var elementTop = el.offset().top, viewportBottom = $(window).scrollTop() + $(window).height();
        return elementTop < viewportBottom;
    }

    function updateQueryStringParameter(key, value, url) {
        if(!url) url = window.location.href;

        var i = url.indexOf('#');
        var hash = i === -1 ? '' : url.substr(i);
        url = i === -1 ? url : url.substr(0, i);

        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        if(value === false) { // added if(value === false) as a means to remove a parameter by setting cphGlobal.updateQueryStringParameter("key",
            // false)
            if(url.match(re)) {
                url = url.replace(re, '$1');
            }
        } else {
            if(url.match(re)) {
                url = url.replace(re, '$1' + key + '=' + value + '$2');
            } else {
                url = url + separator + key + '=' + value;
            }
        }
        url = url.replace(/([?&]+)$/, ''); // added to remove ? or & at end of url if present
        return url + hash;
    }

    $(document).on('ajaxStart.tpl2022', function() {
        var asInt = setInterval(function() {
            if(!$.active) {
                $(document).off('ajaxStart.tpl2022');
                clearInterval(asInt);
                setTimeout(function() {
                    //adaptAllHeadlines(); // Removed 2022-03-25
                    //adaptImages(); // Removed 2022-03-25
                    $(document).trigger('tpl:jsonLoaded');
                    $(document).trigger('tpl2022:jsonLoaded');
                }, 250);
            }
        }, 150);
    });

    var resizeTimer; // debounced
    $(window).on('resize orientationchange', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $(document).trigger('tpl2022:resizeStories');
            adaptAllHeadlines();
            adaptImages();
        }, 250);
    });

    var wait; // throttled
    $(window).on('scroll', function() {
        if(!wait) {
            wait = true;
            setTimeout(function() {
                wait = false;
                adaptImages();
            }, 250);
        }
    });
});
// https://idangero.us/template7/

const tpl20222BlockItems = [];
let tpl2022WidgetIncrement = 0;
let tpl2022WidgetQueueIncrement = 0;
let tpl2022BlockItemsIncrement = 0;

function tpl2022Escape(html, preserveCR) {
    preserveCR = preserveCR ? '&#13;' : '\n';

    return html.toString()
    .replace(/&/g, '&amp;')
    .replace(/'/g, '&apos;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\r\n/g, preserveCR) // Must be before the next replacement.
    .replace(/[\r\n]/g, preserveCR);
}

function tpl2022BuildImage(story, baseSize, sizes, ratio, allowVideo, allowGallery, maxHeight, options) {
    if(!story || !baseSize) return '';

    baseSize = story.image[baseSize] ? baseSize : 'large';

    var src = story.image[baseSize] || story.image.large, pBottom = '75%';

    sizes = sizes || false;
    ratio = ratio || '4:3';
    allowVideo = allowVideo || false;
    maxHeight = maxHeight || false;

    var imgAtts = [];
    imgAtts.push('src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"');
    imgAtts.push('data-src="' + tpl2022Escape(src) + '"');
    imgAtts.push('data-size="' + tpl2022Escape(baseSize) + '"');
    imgAtts.push('data-uuid="' + tpl2022Escape(story.uuid) + '"');
    if(story.image.srcset && sizes) {
        imgAtts.push('data-srcset="' + tpl2022Escape(story.image.srcset) + '"');
        imgAtts.push('data-sizes="' + tpl2022Escape(sizes) + '"');
    }
    imgAtts.push('alt="' + tpl2022Escape(story.image.alt) + '"');

    var hasMaxHeight = '';
    if(maxHeight) hasMaxHeight = ' style="max-height: ' + maxHeight + ';"';

    if(ratio !== '4:3') {
        var pcs = ratio.split(':'), w = parseInt(pcs.shift()), h = parseInt(pcs.shift());

        if(!(isNaN(w) || isNaN(h))) pBottom = ((h / w) * 100).toFixed(2) + '%';
    }

    var html = '<div class="tpl2022__image" data-article-num="' + (options.data.index + 1) + '"' + hasMaxHeight + '>';

    if(allowVideo && story.video.embed.src) {
        html += '<iframe src="" data-src="' + tpl2022Escape(story.video.embed.autoplay || story.video.embed.src) + '" width="100%" allowFullScreen>Your browser does not support iframes</iframe>';
        html += '<div class="tpl2022__video-overlay" onclick="tpl2022VideoClickHandler(this);">';
        html += '<img src="https://img.pressdemocrat.com/shared/play-button.png" alt="play video">';
        html += '</div>';
    } else if(allowGallery) {
        imgAtts.push('data-gallery-uuid="' + tpl2022Escape(story.uuid) + '"');
        imgAtts.push('data-gallery-size="' + tpl2022Escape(baseSize) + '"');
    }

    html += '<a href="' + story.href + '" style="padding-bottom: ' + pBottom + '" aria-label="' + tpl2022Escape(story.headline) + '" tabindex="-1">';
    html += '<img ' + imgAtts.join(' ') + '>';
    html += '</a>';
    html += '</div>';

    return html;
}

function tpl2022BuildCopy(story, hideHeadline, showExcerpt, unwrapCopy, options) {
    var html = '';
    if(!unwrapCopy) html += '<div class="tpl2022__copy">';
    if(!hideHeadline) {
        html += '<div class="tpl2022__headline" data-article-num="' + (options.data.index + 1) + '">';
        html += '<h3 data-article-num="' + (options.data.index + 1) + '">';
        html += '<a href="' + tpl2022Escape(story.href) + '">';
        html += tpl2022Escape(story.headline);
        html += '</a>';
        html += '</h3>';
        html += '</div>';
    }

    if(!!showExcerpt) {
        html += '<div class="tpl2022__excerpt">';
        html += '<p>';
        html += tpl2022Escape(story.description);
        html += '</p>';
        html += '</div>';
    }
    if(!unwrapCopy) html += '</div>';
    return html;
}

function tpl2022BuildArticle(story, baseImageSize, imageSizes, options) {
    var idx = options.data.index, articleClass = options.hash.articleClass,
        printBlockItems = !!options.hash.printBlockItems, articleClasses = [], blockItemsKey = '';

    articleClasses.push('article-' + idx);
    if(options.data.first) articleClasses.push('article-first');
    if(options.data.last) articleClasses.push('article-last');

    if(articleClass) articleClasses.push(articleClass);

    if(printBlockItems) {
        const blockItems = story.block || null;
        if(blockItems) {
            blockItemsKey = ++tpl2022BlockItemsIncrement;
            tpl20222BlockItems[blockItemsKey] = blockItems;
        }
    }

    var html = '<article class="' + articleClasses.join(' ') + '" data-uuid="' + tpl2022Escape(story.uuid) + '" data-tier="' + tpl2022Escape(story.tier) + '" data-hits="' + tpl2022Escape(story.popHits) + '" data-pub-date="' + tpl2022Escape(story.dates.published) + '" data-mod-date="' + tpl2022Escape(story.dates.modified) + '" data-pub-display="' + tpl2022Escape(story.dates.pubDisplay) + '" data-mod-display="' + tpl2022Escape(story.dates.modDisplay) + '" data-mod-text="' + tpl2022Escape(story.dates.modText) + '" data-block-items-key="' + blockItemsKey + '">';
    html += '<div class="tpl2022__wrap">';
    html += tpl2022BuildImage(story, baseImageSize, imageSizes, options.hash.imageRatio, options.hash.allowVideo, options.hash.allowGallery, options.hash.imageMaxHeight, options);
    html += tpl2022BuildCopy(story, options.hash.hideHeadline, options.hash.showExcerpt, options.hash.unwrapCopy, options);
    html += '</div>';
    html += '</article>';

    return html;
}

function tpl2022VideoClickHandler(clicked) {
    (function($) {
        clicked = $(clicked);
        $('.tpl2022__video-overlay').each(function() {
            var parent = $(this).closest('article'), outer = parent.find('.tpl2022__image'),
                overlay = outer.find('.tpl2022__video-overlay:first'), iframe = outer.find('iframe:first');

            if(overlay.is(clicked)) {
                var src = iframe.attr('data-src');
                iframe.attr('src', src);
                parent.addClass('tpl2022--video-is-playing');
            } else {
                iframe.attr('src', '');
                parent.removeClass('tpl2022--video-is-playing');
            }
        });
    })(jQuery);
}

$(document).on('tpl2022:imageLoaded', function(e, image) {
    tpl2022ImageAddGallery(image);
});

$(document).on('tpl2022:forceGallery', function(e, image) {
    tpl2022ImageForceGallery(image);
});

function tpl2022ImageForceGallery(image) {
    image = $(image);

    if(image.is('.loaded')) {
        var uuid = image.data('uuid'), size = image.data('size');

        if(!(uuid && size)) return;

        image.attr('data-gallery-uuid', uuid);
        image.attr('data-gallery-size', size);

        tpl2022ImageAddGallery(image);
    } else {
        image.on('tpl2022:imageLoaded', function() {
            tpl2022ImageForceGallery(image);
        });
    }
}

function tpl2022ImageAddGallery(image) {
    image = $(image);
    if(image.length) {
        var article = image.closest('article'), uuid = image.data('gallery-uuid'), size = image.data('gallery-size'),
            sizes = image.attr('sizes') || '100vw', isVideo = article.find('.tpl2022__video-overlay').length,
            wrap = image.closest('a');

        if(isVideo) return; // no slideshow if first slide is a video

        if(!uuid) return; // if uuid not set, we can't proceed
        if(!size) return; // if size not set, we can't proceed
        if(!wrap.length) return; // if not present, this won't work

        // Get image object from feed server. This means that this will only work for Naviga publications
        var json = $.getJSON('/smi/feeds/json/images/?uuid=' + uuid + '&size=' + size);
        json.done(function(data) {
            var validImages = [];
            $.each(data.images, function(i, image) {
                if(image.video.id) return; // exclude videos
                if(image.image.orientation !== 'horizontal') return; // exclude portrait images
                validImages.push(image);
            });

            if(validImages.length <= 1) return;

            var sContainer = $('<div class="swiper-container"/>'), sWrapper = $('<div class="swiper-wrapper"/>'),
                sSlide = $('<div class="swiper-slide"/>'), sImg = $('<img class="swiper-lazy"/>'),
                sPl = $('<div class="swiper-lazy-preloader swiper-lazy-preloader-white"/>'), slides = [];

            sContainer.css({
                position: 'absolute', width: '100%', height: '100%', background: '#777777'
            });

            sImg.css({
                color: 'transparent', objectFit: 'cover'
            });

            $.each(validImages, function(i, obj) {
                var img = obj.image, thisImg = sImg.clone(), thisSlide = sSlide.clone();

                thisImg.attr('sizes', sizes);
                thisImg.attr('alt', img.alt);

                if(i === 0) { // first slide
                    thisImg.attr('src', img.href);
                    thisImg.attr('srcset', img.srcset);
                    thisImg.removeClass('swiper-lazy');

                    thisSlide.html(thisImg);
                } else {
                    thisImg.attr('data-src', img.href);
                    thisImg.attr('data-srcset', img.srcset);

                    thisSlide.html([thisImg, sPl.clone()]);
                }

                slides.push(thisSlide);
            });

            if(slides.length) {
                sWrapper.html(slides);
                sContainer.html(sWrapper);
                wrap.html(sContainer);

                cphLoader.loadSwiper(function() {
                    new Swiper(sContainer[0], {
                        navigation      : false, allowTouchMove: false, autoplay: {
                            delay: 4000, pauseOnMouseEnter: true
                        }, preloadImages: false, lazy: {
                            loadPrevNext: true
                        }, effect       : 'fade', loop: true, slidesPerView: 1
                    });
                });
            }
        });
    }
}

function tpl2022GetBlockItems(blockItemsKey) {
    return tpl20222BlockItems[blockItemsKey] || null;
}

function tpl2022BuildWidgetOpen(widgetNum, options) {
    var widgetClasses = ['tpl2022__widget', 'tpl2022__widget--' + widgetNum],
        widgetId = options.hash.widgetId || 'tpl2022-widget-' + (++tpl2022WidgetIncrement);

    if(options.hash.widgetClass) widgetClasses.push(options.hash.widgetClass);

    return '<aside id="' + widgetId + '" class="' + widgetClasses.join(' ') + '">';
}

function tpl2022BuildWidgetClose() {
    return '</aside>';
}

function tpl2022BuildWidget(widgetNum, options) {
    return tpl2022BuildWidgetOpen(widgetNum, options) + tpl2022BuildWidgetClose();
}

function tpl2022BuildWidgetQueue(minWidgets, options) {
    var queueClasses = ['tpl2022__widget-queue'],
        queueId = options.hash.queueId || 'tpl2022-widget-queue-' + (++tpl2022WidgetQueueIncrement);

    if(options.hash.queueClasses) queueClasses.push(options.hash.queueClasses);

    return '<aside id="' + queueId + '" class="' + queueClasses.join(' ') + '" data-min-widgets="' + minWidgets + '"></aside>';
}

/**
 * tpl2022Article available options w/ defaults
 * to be entered as {{tpl2022Article 'large' '100vw' imageRatio='16:9' allowVideo='true' ...}}
 *
 * imageRatio      = '4:3'
 * imageMaxHeight  = 'none'
 * allowVideo      = false
 * allowGallery    = false
 * hideHeadline    = false
 * showExcerpt     = false
 * unwrapCopy      = false
 * articleClass    = false
 * printBlockItems = false
 */
Template7.registerHelper('tpl2022Article', function(baseImageSize, imageSizes, options) {
    return tpl2022BuildArticle(this, baseImageSize, imageSizes, options);
});

Template7.registerHelper('tpl2022Image', function(baseSize, sizes, ratio, allowVideo, allowGallery, maxHeight, options) {
    return tpl2022BuildImage(this, baseSize, sizes, ratio, allowVideo, allowGallery, maxHeight, options);
});

Template7.registerHelper('tpl2022Copy', function(hideHeadline, showExcerpt, unwrapCopy, options) {
    return tpl2022BuildCopy(this, hideHeadline, showExcerpt, unwrapCopy, options);
});

Template7.registerPartial('tpl2022PartWidget', '<aside class="tpl2022__widget"></aside>');

Template7.registerHelper('tpl2022WidgetQueue', function(minWidgets, options) {
    return tpl2022BuildWidgetQueue(minWidgets, options);
});

Template7.registerHelper('tpl2022Widget', function(widgetNum, options) {
    return tpl2022BuildWidget(widgetNum, options);
});

Template7.registerHelper('tpl2022WidgetOpen', function(widgetNum, options) {
    return tpl2022BuildWidgetOpen(widgetNum, options);
});

Template7.registerHelper('tpl2022WidgetClose', function() {
    return tpl2022BuildWidgetClose();
});



